import {format} from 'date-fns';
import {fr} from 'date-fns/locale';

/**
 * Les dates du back-office, en français et au même format partout.
 *
 * Elles étaient écrites à l'anglaise (`August 25, 2026`) par la douzaine
 * d'appels à `format` disséminés dans les écrans, chacun avec son propre
 * gabarit. Une convention posée ici vaut mieux qu'une locale répétée douze
 * fois : le jour où le format change, il ne change qu'ici.
 */

/** 25 août 2026 */
export const laDate = (date: Date) => format(date, 'd MMMM yyyy', {locale: fr});

/** 25 août 2026 à 09:06 */
export const laDateEtHeure = (date: Date) =>
    format(date, "d MMMM yyyy 'à' HH:mm", {locale: fr});

/** 25 août — pour les colonnes serrées, où l'année encombre. */
export const laDateCourte = (date: Date) =>
    format(date, 'd MMM yyyy', {locale: fr});
